import React from "react";
import { Drawer } from "antd";
import { isoDateToHumanReadableDate } from "../../Util";
import ProjectComponent from "./components/ProjectComponent";
import CouncilComponent from "./components/CouncilComponent";
import ProcuringEntityComponent from "./components/ProcuringEntityComponent";
import PackageComponent from "./components/PackageComponent";
import PackageContractComponent from "./components/PackageContractComponent";
import EshPdfReportComponent from "./components/EshPdfReportComponent";
import MissingProjectNameComponent from "./components/MissingProjectNameComponent";
import MissingLgaNameComponent from "./components/MissingLgaNameComponent";
import MissingPackageNameComponent from "./components/MissingPackageNameComponent";
import MissingCouncilNameComponent from "./components/MissingCouncilNameComponent";
import MissingSubProjectNameComponent from "./components/MissingSubProjectNameComponent";
import GrievanceCategoryListComponent from "./components/GrievanceCategoryListComponent";
import GrievanceStatusListComponent from "./components/GrievanceStatusListComponent";
import CurrencyComponent from "./components/CurrencyComponent";
import PositionComponent from "./components/PositionComponent";
import RapStatusComponent from "./components/RapStatusComponent";
import VendorGenderComponent from "./components/VendorGenderComponent";
import VulnerabilityComponent from "./components/VulnerabilityComponent";
import VendorCategoryComponent from "./components/VendorCategoryComponent";
import UnknownCountryComponent from "./components/UnknownCountryComponent";
import UnitComponent from "./components/UnitComponent";
import ContractorComponent from "./components/ContractorComponent";
import SubProjectComponent from "./components/SubProjectComponent";
import SubProjectTypeComponent from "./components/SubProjectTypeComponent";
import DistrictComponent from "./components/DistrictComponent";
import UserComponent from "./components/UserComponent";
import FinancierComponent from "./components/FinancierComponent";
import ProjectComponentExceptionComponent from "./components/ProjectComponentExceptionComponent";


export const ExceptionTypes = {
    PROJECT_EXCEPTION: 'project_exception',
    COUNCIL_EXCEPTION: 'council_exception',
    PROCURING_ENTITY_EXCEPTION: 'procuring_entity_exception',
    PACKAGE_EXCEPTION: 'package_exception',
    PACKAGE_CONTRACT_EXCEPTION: 'package_contract_exception',
    ESH_PDF_REPORT_EXCEPTION: 'esh_pdf_report_exception',
    MISSING_PROJECT_NAME_EXCEPTION: 'missing_project_name',
    MISSING_LGA_NAME_EXCEPTION: 'missing_lga_name',
    MISSING_PACKAGE_NAME_EXCEPTION: 'missing_package_name',
    MISSING_COUNCIL_NAME_EXCEPTION: 'missing_council_name',
    MISSING_SUB_PROJECT_NAME_EXCEPTION: 'missing_sub_project_name',
    GRIEVANCE_CATEGORY_LIST_EXCEPTION: 'grievance_category_list_exception',
    GRIEVANCE_STATUS_LIST_EXCEPTION: 'grievance_status_list_exception',
    CURRENCY_EXCEPTION: 'currency_exception',
    POSITION_EXCEPTION: 'position_exception',
    RAP_STATUS_EXCEPTION: 'rap_status_exception',
    VENDOR_GENDER_EXCEPTION: 'vendor_gender_exception',
    VULNERABILITY_EXCEPTION: 'vulnerability_exception',
    VENDOR_CATEGORY_EXCEPTION: 'vendor_category_exception',
    UNKNOWN_COUNTRY_ID_EXCEPTION: 'unknown_country_id',
    UNIT_EXCEPTION: 'unit_exception',
    CONTRACTOR_EXCEPTION: 'contractor_exception',
    SUB_PROJECT_EXCEPTION: 'sub_project_exception',
    SUB_PROJECT_TYPE_EXCEPTION: 'sub_project_type_exception',
    DISTRICT_EXCEPTION: 'district_exception',
    USER_EXCEPTION: 'user_exception',
    FINANCIER_EXCEPTION: 'financier_exception',
    PROJECT_COMPONENT_EXCEPTION: 'project_component_exception'
};

export const ExceptionStatus = {
    RESOLVED: 'resolved',
    PENDING: 'pending'
};



const ComponentSwitcher = ({ exception, onClose, onResolved }) => {
    const renderComponentByStatus = () => {
        switch (exception.type) {
            case ExceptionTypes.PROJECT_EXCEPTION:
                return <ProjectComponent onClose={onClose} exception={exception} onResolved={onResolved} />;
            case ExceptionTypes.COUNCIL_EXCEPTION:
                return <CouncilComponent onClose={onClose} exception={exception} onResolved={onResolved} />;
            case ExceptionTypes.PROCURING_ENTITY_EXCEPTION:
                return <ProcuringEntityComponent onClose={onClose} exception={exception} onResolved={onResolved} />;
            case ExceptionTypes.PACKAGE_EXCEPTION:
                return <PackageComponent onClose={onClose} exception={exception} onResolved={onResolved} />;
            case ExceptionTypes.PACKAGE_CONTRACT_EXCEPTION:
                return <PackageContractComponent onClose={onClose} exception={exception} onResolved={onResolved} />;
            case ExceptionTypes.ESH_PDF_REPORT_EXCEPTION:
                return <EshPdfReportComponent onClose={onClose} exception={exception} onResolved={onResolved} />;
            case ExceptionTypes.MISSING_PROJECT_NAME_EXCEPTION:
                return <MissingProjectNameComponent onClose={onClose} exception={exception} onResolved={onResolved} />;
            case ExceptionTypes.MISSING_LGA_NAME_EXCEPTION:
                return <MissingLgaNameComponent onClose={onClose} exception={exception} onResolved={onResolved} />;
            case ExceptionTypes.MISSING_PACKAGE_NAME_EXCEPTION:
                return <MissingPackageNameComponent onClose={onClose} exception={exception} onResolved={onResolved} />;
            case ExceptionTypes.MISSING_COUNCIL_NAME_EXCEPTION:
                return <MissingCouncilNameComponent onClose={onClose} exception={exception} onResolved={onResolved} />;
            case ExceptionTypes.MISSING_SUB_PROJECT_NAME_EXCEPTION:
                return <MissingSubProjectNameComponent onClose={onClose} exception={exception} onResolved={onResolved} />;
            case ExceptionTypes.GRIEVANCE_CATEGORY_LIST_EXCEPTION:
                return <GrievanceCategoryListComponent onClose={onClose} exception={exception} onResolved={onResolved} />;
            case ExceptionTypes.GRIEVANCE_STATUS_LIST_EXCEPTION:
                return <GrievanceStatusListComponent onClose={onClose} exception={exception} onResolved={onResolved} />;
            case ExceptionTypes.CURRENCY_EXCEPTION:
                return <CurrencyComponent onClose={onClose} exception={exception} onResolved={onResolved} />;
            case ExceptionTypes.POSITION_EXCEPTION:
                return <PositionComponent onClose={onClose} exception={exception} onResolved={onResolved} />;
            case ExceptionTypes.RAP_STATUS_EXCEPTION:
                return <RapStatusComponent onClose={onClose} exception={exception} onResolved={onResolved} />;
            case ExceptionTypes.VENDOR_GENDER_EXCEPTION:
                return <VendorGenderComponent onClose={onClose} exception={exception} onResolved={onResolved} />;
            case ExceptionTypes.VULNERABILITY_EXCEPTION:
                return <VulnerabilityComponent onClose={onClose} exception={exception} onResolved={onResolved} />;
            case ExceptionTypes.VENDOR_CATEGORY_EXCEPTION:
                return <VendorCategoryComponent onClose={onClose} exception={exception} onResolved={onResolved} />;
            case ExceptionTypes.UNKNOWN_COUNTRY_ID_EXCEPTION:
                return <UnknownCountryComponent onClose={onClose} exception={exception} onResolved={onResolved} />;
            case ExceptionTypes.UNIT_EXCEPTION:
                return <UnitComponent onClose={onClose} exception={exception} onResolved={onResolved} />;
            case ExceptionTypes.CONTRACTOR_EXCEPTION:
                return <ContractorComponent onClose={onClose} exception={exception} onResolved={onResolved} />;
            case ExceptionTypes.SUB_PROJECT_EXCEPTION:
                return <SubProjectComponent onClose={onClose} exception={exception} onResolved={onResolved} />;
            case ExceptionTypes.SUB_PROJECT_TYPE_EXCEPTION:
                return <SubProjectTypeComponent onClose={onClose} exception={exception} onResolved={onResolved} />;
            case ExceptionTypes.DISTRICT_EXCEPTION:
                return <DistrictComponent onClose={onClose} exception={exception} onResolved={onResolved} />;
            case ExceptionTypes.USER_EXCEPTION:
                return <UserComponent onClose={onClose} exception={exception} onResolved={onResolved} />;
            case ExceptionTypes.FINANCIER_EXCEPTION:
                return <FinancierComponent onClose={onClose} exception={exception} onResolved={onResolved} />;
            case ExceptionTypes.PROJECT_COMPONENT_EXCEPTION:
                return <ProjectComponentExceptionComponent onClose={onClose} exception={exception} onResolved={onResolved} />;
            default:
                return <div>No matching component found for this exception.</div>;
        }
    };

    return (
        <div>
            {renderComponentByStatus()}
        </div>
    );
};


const ExceptionDrawer = ({ visible, onClose, exception, onResolved }) => {
    if (!exception) return null;

    return (
        <Drawer
            title="Exception Details"
            width={520}
            onClose={onClose}
            visible={visible}
            bodyStyle={{ paddingBottom: 24 }}
        >
            <div>
                <div>
                    <p><strong>Name:</strong> {exception.name}</p>
                    <p><strong>Description:</strong> {exception.description}</p>
                    <p><strong>Type:</strong> {exception.type}</p>
                    <p><strong>Status:</strong> {exception.status}</p>
                    <p><strong>Reporting Period:</strong> {isoDateToHumanReadableDate(exception.report_start_date)} - {isoDateToHumanReadableDate(exception.report_end_date)}</p>
                    <p><strong>Project Name:</strong> {exception.project_name || "==//=="}</p>
                    <p><strong>Council Name:</strong> {exception.council_name || "==//=="}</p>
                    <p><strong>Reporter:</strong> {exception.reporter || "==//=="}</p>
                    <p><strong>Submission ID:</strong> {exception.submission_id || "==//=="}</p>
                    {exception.form_section && (
                        <p style={{ background: '#e6f7ff', padding: '8px', borderRadius: '4px', border: '1px solid #91d5ff' }}>
                            <strong>Form Section:</strong> {exception.form_section}
                        </p>
                    )}
                    {exception.kobo_field_path && (
                        <p><strong>Field Path:</strong> <code style={{ background: '#f5f5f5', padding: '2px 6px', borderRadius: '3px' }}>{exception.kobo_field_path}</code></p>
                    )}
                    <p><strong>Report Type:</strong> {exception.report_type || "==//=="}</p>
                    <p><strong>Created At:</strong> {isoDateToHumanReadableDate(exception.created_at)}</p>
                    <p><strong>Updated At:</strong> {isoDateToHumanReadableDate(exception.updated_at)}</p>
                </div>
                <div style={{ position: 'relative' }}>
                <ComponentSwitcher onClose={onClose} exception={exception} onResolved={onResolved} />
                </div>
            </div>
        </Drawer>
    );
};


export default ExceptionDrawer;
